module.exports = __webpack_public_path__ + "static/img/gs1.74da12d2.jpg";